{
    "ModalTitleMc": "Make a call",
    "ModalTitleTo": "Send call to",
    "ModalTitleMcc": "Inquiry transfer to",
    "SubTitle": "Choose telephone number",
    "SelectLabel": "Telephone No:",
    "SelectPlaceholder": "e.g. 01234567899",
    "SelectNoItems": "Unknown number",
    "FooterHelp": "Help",
    "FooterOk": "OK",
    "FooterClose": "Close",
    "NAME": "CallTargetting",
    "CallTargetting_Description": "Select an internal destination device from the list or manually enter in the destination telephone number."
}